import {
  MDBAlert,
  MDBBtn,
  MDBBtnGroup,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getGlobalLocationList, getusergroups, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import PopupLoader from "../../views/popups/PopupLoader";
import DeleteUserGroup from "../../views/popups/usergroups/DeleteUserGroup";
import AddUsersGroups from "../../views/popups/users/AddUsersGroups";
import DeleteGroupUserFilter from "../../views/popups/users/DeleteGroupUserFilter";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import CommonMoreOptions from "../../apiclients/CommonMoreOptions";
import { isFiveNineAccount } from "../../views/Login";
import TabIDConstant from "../../apiclients/TabIDConstant";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../editviews/user/ImportUser";
export default function MGroups(props) {
  /************************************************************************/
  const [groups, setGroups] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(true);
  const [userGroups, setuserGroups] = useState([])
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [deleteUGroup, setDeleteUGroup] = useState(false);
  const dtogglePopup = () => setDeleteUGroup(!deleteUGroup);
  const [successMessage, setSuccessMessage] = useState("");
  const [AddUserGroup, setAddUserGroup] = useState(false);
  const toggleShow46 = () => setAddUserGroup(!AddUserGroup);
  const [groupSelected, setgroupSelected] = useState("");
  const [groupSelectedIds, setgroupSelectedIds] = useState([]);
  const [newGroupSelectedIds, setNewGroupSelectedIds] = useState([]);
  const [existGroupSelectIds, setexistGroupSelectIds] = useState([]);
  const [existNewGroupSelectIds, setexistNewGroupSelectIds] = useState([]);
  const [filterGroupList, setfilterGroupList] = useState([]);
  const [displayFilterGroups, setdisplayFilterGroups] = useState([]);
  const [displayNewFilterGroups, setdisplayNewFilterGroups] = useState([]);
  const [reRender, setreRender] = useState(true);
  const [searchMainValue, setsearchMainValue] = useState("");
  const [searchEditValue, setsearchEditValue] = useState("");
  const [deleteFilter, setdeleteFilter] = useState(false);
  const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
  const [allGroups, setallGroups] = useState(false);
  const [allNewGroups, setallNewGroups] = useState(false);
  const addUserGrpRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowdata, setRowData] = useState([]);
  const [allChecked, setallChecked] = useState(false);
  const [disableMulti, setdisableMulti] = useState(true);
  const [groupList, setgroupList] = useState([]);
  const [groupNames, setgroupNames] = useState([]);
  const isFiveNineAccounts = isFiveNineAccount();
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
const filterSearchRef = useRef(null);
const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [DropDownitem, setDropDownitem] = useState([
    {
      label: "Caller-ID",
      key: "caller-id",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Location",
      key: "location",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Billing Group",
      key: "billing-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Seat Plan",
      key: "seat-plan",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Permission Role",
      key: "permission-role",
      show: !isFiveNineAccounts,
    },
    {
      label: "Add to a Group",
      key: "add-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Resend Welcome Email",
      key: "resend-email",
    },
  ]);

  function handleClick() {
    addUserGrpRef.current.click();
  }

  /*************************************************************************/
  function showThisInf(tdata) {
    navigate("/selectedusergroupsettings", {
      state: tdata.groupInfo,
    });
  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function fetchUserGroupData() {
    try {
      console.log(sessionStorage.getItem("admin_session"));
      const response = await getusergroups(JSON.parse(sessionStorage.getItem("admin_session")).siteid, TabIDConstant.USER_GRPS_SUBLINK);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const rawData = await response.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      console.log("response data is :::::::::: " + rawData);
      setIsloading(true);
      setuserGroups(rawData?.usergroups ?? []);
      setTimeout(() => {
        setIsloading(false);
      }, 1000);

    } catch (error) {

    }
  }

  function deletethisGroup(evntData, groupId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    setSelectedGroupId(groupId);
    dtogglePopup();
  }
  const handleAllChecked = (isChecked) => {
    if (isChecked) {
      setallChecked(true);
      const grpIds = [];
      const grpNames = [];
      filteredRows.forEach(({ usergroup_id, usergroup_name }) => {
        grpIds.push(usergroup_id + "");
        grpNames.push(usergroup_name);
      });
      setgroupList(grpIds);
      setgroupNames(grpNames);
      setdisableMulti(false);


    } else {
      setallChecked(false);
      setgroupList([]);
      setgroupNames([]);
      setdisableMulti(true);
    }
  }

  function handleCheckedRow(e, selectrow) {
    // e.preventDefault();
    let groups = selectrow.usergroup_id + "";
    let groupname = selectrow.usergroup_name;
    let updatedGroups = [];
    let updatedGroupNames = [];

    if (e.target.checked) {
      updatedGroups = [...groupList, groups];
      updatedGroupNames = [...groupNames, groupname];


    } else {
      updatedGroups = groupList.filter((tmdata) => tmdata !== groups);
      updatedGroupNames = groupNames.filter((tmdata) => tmdata !== groupname);

    }

    const allSelected = filteredRows.length > 0 ? filteredRows.every(row => updatedGroups.includes(row.usergroup_id + "")) : false;
    if (allSelected) {
      setallChecked(true);
    } else {
      setallChecked(false);
    }
    if (updatedGroups.length > 0) {
      setdisableMulti(false);
    } else {
      setdisableMulti(true);
    }
    setgroupList(updatedGroups);
    setgroupNames(updatedGroupNames);
  }

  useEffect(() => {
    let proccessdRows = [];
    userGroups.map((group) => {
      proccessdRows.push({
        groupInfo: group,
        checkBoxValue: (<>
          <MDBCheckbox checked={groupList.includes(group.usergroup_id + "")} onClick={(e) => handleCheckedRow(e, group)} />
        </>),
        usergroup_name: group.usergroup_name + "",
        user: group.users_count + "",
        usergroup_id: group.usergroup_id,
        remove: (
          <>

          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisGroup(e, group.usergroup_id)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
          {/* <a className="ms-3"
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => deletethisGroup(e, group.usergroup_id)}
            target="_new"
          >
            <MDBIcon fas icon="times" className="green" title="Remove" />
          </a> */}
        </>
      )
    })
  })
  setRowData(proccessdRows);
  setFilteredRows(proccessdRows);
    setDataLoaded(true)
  }, [userGroups,props.isActive])

useEffect(() => {
    setFilteredRows(filteredRows.map(group => ({
      ...group, checkBoxValue: (<>
        <MDBCheckbox checked={groupList.includes(group.usergroup_id + "")} onClick={(e) => handleCheckedRow(e, group)} />
      </>)
    })))
  }, [groupList]);

  const basicData = {
    columns: [
      {
        label: (<>
          <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
        </>), field: "checkBoxValue", sort: false
      },
      { label: 'Name', field: 'usergroup_name' },
      { label: 'Users', field: 'user' },
      { label: 'Remove', field: 'remove', sort: false },
    ],
    rows: rowdata,
  };
  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    fetchUserGroupData();
  }, []);

  /********************************************************************************* */

  useEffect(() => {
    if (reRender) {
      // const userGroupFilter = sessionStorage.getItem("userGroupFilter") ?
      //   JSON.parse(sessionStorage.getItem("userGroupFilter")) :
      //   [];
      // const ugroupupdated = sessionStorage.getItem("ugroup_updated");
      // if (userGroupFilter && userGroupFilter.length > 0 && !ugroupupdated) {
      //   setTheStateValues(userGroupFilter);
      // } else {
      //   sessionStorage.removeItem('ugroup_updated');
      getUserGroupFilter();
      // }
      setreRender(false);
    }
  }, [reRender]);


  async function getUserGroupFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=5`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      console.log(" Global user Group filter ::::::::: : " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      const userGroupsFilter = rawData?.result ?? [];
      setTheStateValues(userGroupsFilter);
      // sessionStorage.setItem("userGroupFilter", JSON.stringify(userGroupsFilter));

    } catch (error) {

    }

  }

  function setTheStateValues(userGroupsFilter) {
    let groupSelected = userGroupsFilter.filter(userGroup => userGroup.selected).map(userGroup => userGroup.entity_name).join(', ');
    const groupSelectedids = userGroupsFilter.some(userGroup => userGroup.entity_id === -1 && userGroup.selected)
      ? userGroupsFilter.map(userGroup => userGroup.entity_id)
      : userGroupsFilter.filter(userGroup => userGroup.selected).map(userGroup => userGroup.entity_id);

    const index = groupSelectedids.findIndex(id => id === -1);
    if (index !== -1) {
      groupSelectedids.splice(index, 1);
      groupSelected = "";
      setNewGroupSelectedIds(groupSelectedids);
      // setallLocation(true);
      setexistNewGroupSelectIds(groupSelectedids);
      setallNewGroups(true);
    }

    const newuserGroupsFilter = userGroupsFilter.filter((grp) => parseInt(grp.entity_id) !== -1);

    setfilterGroupList(newuserGroupsFilter);
    setdisplayFilterGroups(newuserGroupsFilter);
    setdisplayNewFilterGroups(newuserGroupsFilter);
    if (groupSelected && groupSelected !== "") {
      setgroupSelected(`${t("usergroups")} : ${groupSelected}`);
      setgroupSelectedIds(groupSelectedids);
      setexistGroupSelectIds(groupSelectedids);

    }

  }

  function cancelfilterChanges(flag) {
    if (flag === 1) {
      setgroupSelectedIds(existGroupSelectIds);
      if (existGroupSelectIds.length === filterGroupList.length || existGroupSelectIds.length === displayFilterGroups.length) {
        setallGroups(true);
      } else {
        setallGroups(false);

      }
    } else {
      setNewGroupSelectedIds(existNewGroupSelectIds);
      if (existNewGroupSelectIds.length === filterGroupList.length || existNewGroupSelectIds.length === displayFilterGroups.length) {
        setallNewGroups(true);
      } else {
        setallNewGroups(false);
      }
    }
  }

  const handleFilterCheckboxChange = (value) => {
    const updatedValues = [...groupSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterGroups.length) {
      setallGroups(false);
    } else {
      const tempArray = displayFilterGroups.map(grp => grp.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallGroups(false);
          break;
        }
      }
      setallGroups(true);
    }
    setgroupSelectedIds(updatedValues);
  };

  const handleNewFilterCheckboxChange = (value) => {
    const updatedValues = [...newGroupSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }

    if (updatedValues.length !== displayNewFilterGroups.length) {
      setallNewGroups(false);
    } else {
      const tempArray = displayNewFilterGroups.map(grp => grp.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallNewGroups(false);
          break;
        }
      }
      setallNewGroups(true);
    }

    setNewGroupSelectedIds(updatedValues);
  };


  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  const handleSubmit = async (event, selectValue) => {
    event.preventDefault();
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    let filteredValue = [...selectValue];
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    if (selectValue.length === filterGroupList.length) {
      filteredValue = [-1];

    }
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: filteredValue,
      filter_type: 1,
      filter_key: 7,
      module_type: 5,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify group user filter value  :::: " + JSON.stringify(update));
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit group user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified group user data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
      // sessionStorage.removeItem('userGroupFilter');

      navigate("/userlanding", {
        state: { tab: "mgroups" },
      });
      window.location.reload();
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  function handleSearch(e, flag) {
    const value = e.target.value;
    if (flag === 1) {
      setsearchMainValue(value);
      setdisplayFilterGroups(customSearch(filterGroupList, value, ['entity_name']));
    } else {
      setsearchEditValue(value);
      setdisplayNewFilterGroups(customSearch(filterGroupList, value, ['entity_name']));
    }


  }

  function setDefaultValue(e) {
    e.preventDefault();
    if (groupSelected) {
      setNewGroupSelectedIds([]);
    }
  }

  function handleAllGroup(e) {
    // e.preventDefault();
    setallGroups(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterGroups.map(loc => loc.entity_id);
      setgroupSelectedIds(locId);
    } else {
      setgroupSelectedIds([]);
    }

  }
  function handleNewAllGroup(e) {
    // e.preventDefault();
    setallNewGroups(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterGroups.map(loc => loc.entity_id);
      setNewGroupSelectedIds(locId);
    } else {
      setNewGroupSelectedIds([]);
    }

  }

  function removegrpFilter() {
    removeThisFilter(7);

  }

  const removeallfilters = (value) => {
    removeThisFilter(-1);

  }

  async function removeThisFilter(filterKey) {
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 5,
    }

    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      navigate("/userlanding", {
        state: { tab: "mgroups" },
      });

      window.location.reload();
    } else {
      localStorage.setItem("s_message", deleteMsg.message);
      // sessionStorage.removeItem('userGroupFilter');
      navigate("/userlanding", {
        state: { tab: "mgroups" },
      });

      window.location.reload();
    }
  }

  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(rowdata, searchValue, UIConstant.MGROUPS);

    setFilteredRows(filteredUsers);
};

  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBSpinner className="ms-2" color="primary">
              <span className="visually-hidden">Loading...</span>
            </MDBSpinner>
          </div>
        </>
      )}

      <div className="position-absolute left__341px">
        <div className="d-flex">
          <div className="mx-3 popconfirmFilter">
            {groupSelected && (
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip  className="m-0" onClick={(e) => setDefaultValue(e)}
                 
                >
                  <div className="filterElliipse">
                    {groupSelected}
                  </div>
                      <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => {e.stopPropagation(); removegrpFilter() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage className="p-2">
                  <p className='mb-2 fw-600'>
                    {t("UsersGroup")}
                  </p>

                  <div className="d-flex align-items-center">
                    <div className="ms-2 w-100">
                      <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e, 1)} />
                    </div>
                  </div>
                  <div className="filter-border py-2"></div>
                  <div className="mt-3">
                    <MDBCheckbox checked={allGroups} onChange={(e) => handleAllGroup(e)} label='Select All' />
                  </div>
                  <div className="filtersScroll">
                    {displayFilterGroups && displayFilterGroups.map((group) => (
                      <MDBCheckbox name='flexCheck' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={groupSelectedIds.includes(group.entity_id)}
                        onChange={() => handleFilterCheckboxChange(group.entity_id)}
                      />
                    ))}
                  </div>
                  <div className="filter-border"></div>
                  <div className="d-flex float-end mt-3">
                    {(groupSelectedIds.length > 0 && !isArraysEqual(groupSelectedIds, existGroupSelectIds)) && (
                      <>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                          handleSubmit(e, groupSelectedIds);
                        }}> Apply</MDBBtn>
                      </>
                    )}

                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            )}
          </div>
          {!groupSelected && (
            <MDBPopconfirm placement='bottom-start'  onClick={(e) => { setDefaultValue(e); setIsFilterOpen(true); }} onClose={() => setIsFilterOpen(false)} className="shadow-6" btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
              <MDBPopconfirmMessage className="p-2">
                <p className='mb-2 fw-600'>
                  {t("UsersGroup")}
                </p>

                <div className="d-flex align-items-center">
                  <div className="ms-2 w-100">
                    <MDBInput ref={filterSearchRef} autoFocus={isFilterOpen} placeholder="search" value={searchEditValue} onChange={(e) => handleSearch(e, 2)} />
                  </div>
                </div>
                <div className="filter-border py-2"></div>
                <div className="mt-3">
                  <MDBCheckbox checked={allNewGroups} id="allNewGroups" onChange={(e) => handleNewAllGroup(e)} label='Select All' />
                </div>
                <div className="filtersScroll">
                  {displayNewFilterGroups && displayNewFilterGroups.map((group) => (
                    <MDBCheckbox name='flexCheck' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={newGroupSelectedIds.includes(group.entity_id)}
                      onChange={() => handleNewFilterCheckboxChange(group.entity_id)}
                    />
                  ))}
                </div>
                {(newGroupSelectedIds.length !== 0 && newGroupSelectedIds.length !== filterGroupList.length) && (
                  <>
                    <div className="filter-border"></div>
                    <div className="d-flex float-end mt-3">
                      <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(2)}>Cancel</MDBBtn>
                      <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                        handleSubmit(e, newGroupSelectedIds);
                      }}> Apply</MDBBtn>
                    </div>
                  </>
                )}

              </MDBPopconfirmMessage>
            </MDBPopconfirm>
          )}
          {groupSelected && (
            <MDBBtn className="mx-2" onClick={removeallfilters}>Clear</MDBBtn>
          )}
        </div>
      </div>

      <div className=" actionbar button_aligniment">

        <div className="float-end">
          {/* 
          <MDBBtn className="btn_adjust me-3">
            <MDBIcon fas icon="filter" /> {t("addFilter")}
          </MDBBtn> */}

          <MDBBtn
            className=" btn_adjust me-3" onClick={toggleShow46}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t('addusergtoup')}
          </MDBBtn>

          <CommonMoreOptions
            DropDownitem={DropDownitem}
            disableMulti={disableMulti}
            agentList={groupList}
            usergroups={true}
            moduleType={2}
            moduleid="common-more-options-portal-usergroups"
            showWarning={true}
            onImpExpRedirect={() => setShowImpExpRedirect(true)}
            onImpExpWarning={(msg) => { setWarningMessage(msg); warningToggle(); }}
          />
          {/* <MDBBtn className="loat-right mt-2_responsive btn_adjust me-3">
            <MDBIcon fas icon="download" /> {t("importusers")}
          </MDBBtn>
          <MDBBtn className=" btn_adjust mt-2_responsive btn_adjust">
            <MDBIcon fas icon="upload" /> {t("exportusers")}
          </MDBBtn>
          <MDBBtnGroup
            aria-label="Button group with nested dropdown"
            className="display-inline ms-3 btn_adjust  h-inherit"
          >
            <MDBBtnGroup>
              <MDBDropdown>
                <MDBDropdownToggle className="px-3">
                  <div className="text-white">
                    <MDBIcon fas icon="ellipsis-v" className="me-2" />
                    More
                  </div>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem link>Caller-ID</MDBDropdownItem>
                  <MDBDropdownItem link>
                    Change Calling Permissions
                  </MDBDropdownItem>
                  <MDBDropdownItem link>Change Location</MDBDropdownItem>
                  <MDBDropdownItem link>Change Billing Group</MDBDropdownItem>
                  <MDBDropdownItem link>Enable/Disable an Add-On</MDBDropdownItem>
                  <MDBDropdownItem link>Change Seat Plan</MDBDropdownItem>
                  <MDBDropdownItem link>Change Permission Role</MDBDropdownItem>
                  <MDBDropdownItem link>Configure Web Integration</MDBDropdownItem>
                  <MDBDropdownItem link>Add to a Group</MDBDropdownItem>
                  <MDBDropdownItem link>Reset Password</MDBDropdownItem>
                  <MDBDropdownItem link>Resend Welcome Email</MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBBtnGroup> 
          </MDBBtnGroup>*/}
        </div>
      </div>

      <div className='mb-2 mt-2 position-relative w-auto'>
        <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
      </div>
      <div className="w-100 usersGroupsDataTable actioncolumn">
        <MDBDatatable  key={searchValue} className="datatableSelect"
          onRowClick={(event, rowData) => {
            showThisInf(event);
          }}
          fixedHeader
          entries={50}
          // multi
          // selectable
          sortOrder="asc"
          sortField="Name"
          searchInputProps={[]}
          data={{
            ...basicData,
            rows: filteredRows, // Use filtered rows here
          }}
          responsive
          hover
        />
      </div>
      {deleteUGroup && (
        <PopupLoaderNew
          title={"Remove User Group"}
          content={<DeleteUserGroup
            groupId={selectedGroupId}
            onClose={dtogglePopup}
            setSuccessMessage={setSuccessMessage}
            ref={addUserGrpRef}
            setIsloading={setisLoading}
          />}
          onShow={setDeleteUGroup}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {AddUserGroup && (
        <PopupLoaderNew
          title={t("AddUserGroup")}
          content={<AddUsersGroups
            setSuccessMessage={setSuccessMessage}
            onClose={toggleShow46}
            ref={addUserGrpRef}
            setIsloading={setisLoading}
          />
          }
          onShow={setAddUserGroup}
          onClose={toggleShow46}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
      {deleteFilter && (
        <PopupLoaderNew
          title={"Delete User"}
          content={<DeleteGroupUserFilter
            onClose={deleteFilterToggle}
            ref={addUserGrpRef}
            setIsloading={setisLoading}
          />}
          onShow={setdeleteFilter}
          onClose={deleteFilterToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}

        />
      )}
      <div id="common-more-options-portal-usergroups"></div>
      {showWarning && (
        <ImportProgressWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={warningToggle}
          message={warningMessage}
        />
      )}
      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}
      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
              {/* <MDBBtn className='btn-close' color='none' onClick={importuserToggle}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}

      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </>
  );
}
